<template lang="pug">
.py-2.height-100
  div
    .h6 Confirme os dados da ocorrência
    .text-small Verifique se as informações estão corretas antes de enviar
  .mt-2.height-100.scrollable(style="height: calc(100vh - 350px);")
    .divider
    .d-flex
      .h5 Categoria
      router-link(:to="{ name: 'app.ouvidoria.create.categoria' }")
        i.fa.fa-pencil-square-o.m-2
    .columns.mt-1.col-gapless.flex-centered
      .column.col-auto
        img.img-categoria.img-responsive.s-rounded(:src="form.categoria.icone")
      .column.ml-2
        | {{ form.categoria.descricao }}
    .divider
    .d-flex
      .h5 Fotos
      router-link(:to="{ name: 'app.ouvidoria.create.fotos' }")
        i.fa.fa-pencil-square-o.m-2
    .columns.mt-1
      .column.col-3.col-sm-6.col-xs-12(v-for="(file, index) in form.fotos" :key="index")
        imagem-local.s-rounded(:file="file")
    .divider
    .d-flex
      .h5 Local
      router-link(:to="{ name: 'app.ouvidoria.create.local' }")
        i.fa.fa-pencil-square-o.m-2
    .mt-2 {{ form.endereco_formatado }}
    div(v-if="form.endereco_complemento") #[small Complemento:] {{ form.endereco_complemento }}
    .divider
    .d-flex
      .h5 Descrição
      router-link(:to="{ name: 'app.ouvidoria.create.descricao' }")
        i.fa.fa-pencil-square-o.m-2
    .mt-2.pre-wrap {{ form.descricao }}
    .divider
    .form-group
      label.form-switch
        input(type="checkbox", v-model="anonimo")
        i.form-icon
        | Enviar de forma anônima
    .divider
    .mt-2.text-right
      button.btn.btn-primary(@click="onSubmit" :class="{ loading: uploadingItem > 0 }" :disabled="uploadingItem > 0")
        | Enviar&nbsp;
        i.fa.fa-paper-plane
</template>

<script>
import FileUpload from '@/lib/FileUpload';
import ImagemLocal from './components/ImagemLocal.vue';
import uploads from '@/api/uploads';

export default {
  vuex: {
    ocorrencias: {
      state: ["form"],
      actions: ['fetchCreate'],
      mutations: ["setForm"],
    },
  },
  data() {
    return {
      uploadingItem: 0,
      anonimo: false,
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.uploadingItem++;
        const anexos = [];
        for (const file of this.form.fotos) {
          const { signedUrl } = await uploads.signedParams();
          const fileUpload = new FileUpload(signedUrl);
          const res = await fileUpload.upload({ file });
          anexos.push({
            file_info: res.currentTarget.response,
          });
        }

        const { categoria, descricao, point, endereco_formatado, endereco_numero, endereco_complemento } = this.form
        const body = {
          processo_categoria_id: categoria.id,
          descricao,
          point,
          endereco_formatado,
          endereco_numero,
          endereco_complemento,
          anexos,
          anonimo: this.anonimo
        };

        await this.fetchCreate(body);
        this.$toaster.success("Ocorrência enviada com sucesso!");
        this.$router.push({ name: "app.ouvidoria" });

      } catch (e) {
        this.$toaster.error(e.message || "Erro ao enviar a ocorrência");
      } finally { 
        this.uploadingItem = 0
      }
    }
  },
  components: { ImagemLocal },
};
</script>

<style lang="stylus" scoped>
.py-2
  .img-categoria
    width: 30px
</style>
